import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ItemsModule } from '../items/items.module';
import { PipesModule } from '../pipes/pipes.module';
import { PrequalificationsEditComponent } from './prequalifications-edit/prequalifications-edit.component';
import { PrequalificationsRoutingModule } from './prequalifications-routing.module';
import { PrequalificationsViewComponent } from './prequalifications-view/prequalifications-view.component';
import { PrequalificationsComponent } from './prequalifications.component';
import { DirectivesModule } from '../directives/directives.module';
import { MyItemsModule } from '../my-items/my-items.module';

export const MATERIAL_MODULES = [
  MatIconModule,
  MatSelectModule,
  MatButtonModule,
  MatInputModule,
  MatTooltipModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatListModule,
  MatCheckboxModule,
  MatDialogModule
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        PrequalificationsRoutingModule,
        ...MATERIAL_MODULES,
        PipesModule,
        ItemsModule,
        DirectivesModule,
        MyItemsModule,
        MatMenuModule,
        MatSlideToggleModule
    ],
    declarations: [
        PrequalificationsComponent,
        PrequalificationsEditComponent,
        PrequalificationsViewComponent
    ],
    exports: [PrequalificationsComponent]
})
export class PrequalificationsModule {}
